<script>
  import { cart } from "$lib/state/cart.js";
  import { parsePrice } from "$lib/utils/parsePrice.js";
  import { onMount } from "svelte";
  import { capitalizeString } from "$lib/utils/capitalizeString";
  import { getProductName } from "$lib/utils/getProductName";
  import { page } from "$app/stores";
  import { dispatchCustomEvent, VIEW_ITEM_EVENT } from "$lib/utils/events.js";
  import { klaviyoViewItem } from "$lib/utils/KlaviyoEvents.js";

  import ShoppingQtyHandle from "$lib/components/cart/ShoppingQtyHandle.svelte";
  import Modal from "$lib/components/Modal.svelte";
  import AddToCart from "$lib/utils/AddToCartFunction";
  import ImageProduct from "$lib/components/products/ImageProduct.svelte";
  import { isOnlyProfessional } from "$lib/utils/onlyProfesionals";

  export let data;

  /** @typedef {import('$lib/types/index.js').PublicProduct} publicProduct */
  /**@type {publicProduct | ??}*/
  let product = data.product;
  let imageMain = 0;
  /**@param {number}index*/
  const selectImage = (index) => {
    imageMain = index;
  };
  let images = product.images.gallery;

  let addToBag = new AddToCart();
  /**@type {number}*/
  let qty = 1;

  let isOpen = false;
  let viewImageSelect = "";
  /**@param {string}image*/
  const viewImage = (image) => {
    isOpen = true;
    viewImageSelect = image;
    console.log(viewImageSelect);
  };
  /**@type {number}*/
  let mxInitial = 0;
  /**@type {number}*/
  let mx = 0;
  /**@type {number}*/
  let selected = 1;
  /**@param {MouseEvent}e*/
  const dragStart = (e) => (mxInitial = e.clientX);
  /**@param {MouseEvent}e*/
  const mouseMove = (e) => (mx = e.clientX);
  /**@param {TouchEvent}e*/
  const touchStart = (e) => mxInitial == e.touches[0].clientX;
  /**@param {TouchEvent}e*/
  const touchMove = (e) => (mx = e.touches[0].clientX);

  const swapImages = () => {
    let index = images?.findIndex(/**@param {string}item*/ (item) => item === viewImageSelect);
    if (mxInitial < mx) {
      if (selected !== 0) {
        index--;
      } else {
        index = 0;
      }
      viewImageSelect = images[index];
    } else if (mxInitial > mx) {
      if (index === images.length - 1) {
        index = images.length - 1;
      } else {
        index++;
      }
      viewImageSelect = images[index];
    }
  };

  /**@type {import ('$lib/types').MagentoCartItem | ??}*/
  let productInCart;
  onMount(() => {
    //@ts-ignore
    if ($cart) {
      productInCart = $cart.items.find((item) => item.sku === product.sku);
      qty = productInCart?.qty || 1;
    }
    dispatchCustomEvent(VIEW_ITEM_EVENT, product);
    klaviyoViewItem(product);
  });
  /**
   * @param {product}product
   * @param {number} qty
   * */
  const changeQty = async (product, qty) => {
    try {
      const formData = new FormData();
      if (productInCart) {
        const formData = new FormData();
        formData.append("itemId", String(productInCart?.item_id));
        formData.append("qty", String(qty));
        formData.append("sku", product.sku);
        const fetch_ = await fetch("/cart", {
          method: "PUT",
          body: formData,
        });
      } else {
        await addToBag.addToCartSingle(product, qty);
      }
    } catch (error) {
      console.log(error);
    }
  };
</script>

<svelte:head>
  <title>
    {capitalizeString(getProductName(product))} - Red Carpet Manicure
  </title>
  <meta property="og:title" content="Red Carpet Manicure" />
  <meta property="og:description" content={`${product.description}`} />
  <meta property="og:locale" content="en_GB" />
  <meta property="og:type" content="product" />
  <meta property="og:url" content={`https://www.redcarpetmanicure.co.uk/${$page.url.pathname}`} />
  <meta property="og:img" content={`${product?.images?.image}-${360}px@2x.webp`} />
  <meta property="og:image:alt" content={`${product.name}`} />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />
  <meta property="og:image" content={`${product?.images?.image}-${360}px@2x.webp`} />
  <meta property="g:image_link" content={`${product?.images?.image}-${360}px@2x.webp`} />

  {#if product?.isInStock}
    <meta property="og:offers:availability" content="https://schema.org/InStock" />
  {:else}
    <meta property="og:offers:availability" content="https://schema.org/OutOfStock" />
  {/if}
  {#if product?.specialPrice !== ""}
    <meta property="og:offers:price" content={product?.specialPrice} />
    <meta
      property="og:offers:priceSpecification:priceType"
      content="https://schema.org/ListPrice"
    />
    <meta property="og:offers:priceSpecification:price" content={product?.price} />
    <meta property="og:offers:priceSpecification:priceCurrency" content="GBP" />
  {:else}
    <meta property="og:offers:price" content={product?.price} />
  {/if}
  <meta property="og:offers:priceCurrency" content="GBP" />
  {#if product.upc}
    <meta property="g:gtin" content={product.upc} />
  {/if}
</svelte:head>

<div class="container">
  <div class="content-left">
    <div class="product-images-overflow">
      <div class="product-images">
        {#if images.length > 0}
          {#each images as image, index}
            <button class="image" class:main={index == imageMain} on:click={() => viewImage(image)}>
              <ImageProduct productImage={image} width={"840"} />
            </button>
          {/each}
        {/if}
      </div>
    </div>
    <div class="product-images">
      {#if images.length > 0}
        {#each images as image, index}
          <button
            class="image-mini"
            class:active={index == imageMain}
            on:click={() => selectImage(index)}
          >
            <ImageProduct productImage={image} width={"840"} />
          </button>
        {/each}
      {/if}
    </div>
  </div>
  <div class="content-right">
    <div class="name">
      <h1>{product.name}</h1>
    </div>
    <div class="in-stock">
      {#if product.isInStock}
        <p>In Stock</p>
      {:else}
        <p class="red">Out Of Stock</p>
      {/if}
      <p>{product.sku}</p>
    </div>
    <div class="price">
      <h2>{parsePrice("GBP", "en-gb", product?.price)}</h2>
    </div>
    <div class="add-to-cart">
      <ShoppingQtyHandle size="max" bind:qty itemId={productInCart?.item_id} />
      {#if isOnlyProfessional(product.sku)}
        <p class="only-professionals">Only for Professional Customers</p>
      {:else}
        <button
          class="add-to-bag"
          on:click={() => {
            if (qty == 1) {
              addToBag.addToCartSingle(product, qty);
            } else {
              changeQty(product, qty);
            }
          }}
        >
          ADD TO BAG
        </button>
      {/if}
    </div>
    {#if product.upc}
      <div class="upc">
        <p><b>GTIN: </b>{@html product.upc}</p>
      </div>
    {/if}
    <div class="short-description">
      <p>{@html product.short_description}</p>
    </div>
  </div>
</div>

<Modal bind:isOpen style="max-width: 95rem">
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="view-content"
    on:dragstart={dragStart}
    on:mousemove={mouseMove}
    on:touchstart|passive={touchStart}
    on:touchmove|passive={touchMove}
    on:dragend={swapImages}
    on:touchend={swapImages}
  >
    <ImageProduct productImage={viewImageSelect} width={"1500"} alt={product.name} />
  </div>
</Modal>

<style>
  .container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100svw;
    padding: 20svh 2rem;
    max-width: 160rem;
    margin: 0 auto;
    gap: 5rem;
    align-items: start;
  }
  .content-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3rem;
    position: sticky;
    top: 10rem;
  }
  .product-images-overflow {
    width: 95%;
    max-width: 68rem;
    aspect-ratio: 1/1;
    overflow: hidden;
    box-shadow: 0 0 1rem 0.1rem rgba(0, 0, 0, 0.2);
    border-radius: 3rem;
    position: relative;
  }
  .product-images {
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 1rem;
  }
  .image {
    width: 100%;
    height: 100%;
    max-width: 68rem;
    border-radius: 3rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all 0.5s ease;
    opacity: 0;
    border: none;
    background: none;
  }
  .image.main {
    left: 0;
    top: 0;
    z-index: 1;
    opacity: 1;
    cursor: pointer;
  }
  .image-mini {
    width: 6rem;
    height: 6rem;
    border-radius: 0.5rem;
    box-shadow: 0 0 0.2rem rgba(0, 0, 0, 0.2);
    opacity: 0.5;
    transition: all 0.5s ease;
    border: none;
    background: none;
    cursor: pointer;
  }
  .image-mini.active {
    border: 1px solid var(--orange);
    opacity: 1;
  }
  .content-right {
    width: 100%;
    padding: 4rem 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }
  .name {
    font-family: sirenia;
    color: var(--pink);
  }
  .name h1 {
    font-size: clamp(3rem, 5svw, 4rem);
    line-height: 1;
    letter-spacing: 0.05rem;
  }
  .in-stock {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--pink);
    font-family: sirenia;
  }
  .in-stock p {
    font-size: 2.4rem;
    font-weight: 500;
  }
  .price {
    font-family: sirenia;
    color: var(--pink);
  }
  .price h2 {
    font-size: clamp(5rem, 10svw, 10rem);
    font-weight: 500;
  }
  .add-to-cart {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 4rem;
  }
  .add-to-cart .add-to-bag {
    width: 20rem;
    height: 4.5rem;
    border: none;
    border-radius: 2.5rem;
    background-color: var(--pink);
    color: var(--white);
    font-family: sirenia;
    letter-spacing: 0.08rem;
    font-size: 1.65rem;
    cursor: pointer;
  }

  .short-description p {
    font-size: 2rem;
    line-height: 1.2;
    letter-spacing: 0.1rem;
  }
  .red {
    color: var(--red);
    font-weight: 700 !important;
  }
  .view-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
  }

  .upc {
    margin-top: 2rem;
  }
  .upc p {
    line-height: 1;
    font-size: 1.8rem;
    letter-spacing: 1px;
  }
  .only-professionals {
    font-size: clamp(1.4rem, 3svw, 1.5rem);
    line-height: 1;
    color: var(--pink);
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    line-height: 1;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
  }
  @media (max-width: 820px) {
    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 12rem 1rem;
    }
    .content-left {
      position: static;
    }
    .product-images-overflow {
      width: 95svw;
    }
  }
</style>
